import AdhocReporting from 'components/global/AdhocReporting';

const LenderAdhocReporting = () => <AdhocReporting />;

export default LenderAdhocReporting;
